export default __webpack_public_path__ + "static/assets/med_pill_square_flat_L1_solid_x_01_f.e427f6a4.png";